import React from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

interface PolarChartProps {
    labels: string[],
    values: string[],
}


export const PolarChart = (props: PolarChartProps) => {

    const data = {
      labels: props.labels,
      datasets: [
        {
          label: 'Annotations',
          data: props.values,
          backgroundColor: [
            'rgba(34, 197, 94, 0.5)',
            'rgba(239,68,68, 0.5)',
            'rgba(238, 238, 238, 0.5)',
            'rgba(75, 192, 192, 0.5)',
            'rgba(153, 102, 255, 0.5)',
            'rgba(255, 159, 64, 0.5)',
          ],
          borderWidth: 1,
        },
        ],
    };

    const charOptions = {
        responsive: true,
        maintainAspectRatio: false,
    }

    return (
        <div className="h-screen">
            <Doughnut data={data} options={charOptions} />
        </div>
    )
} 
